/**
 * ProviderLogo — small provider brand tile (Anthropic / Google).
 * Renders the black-bg tile with the appropriate logo image.
 */
import { LOGO_URL, PROVIDER_META } from './constants';

export function ProviderLogo({ provider, size = 56 }) {
  const meta = PROVIDER_META[provider] || PROVIDER_META.Google;
  return (
    <div
      className="rounded-2xl flex items-center justify-center shrink-0 shadow-lg border"
      style={{
        width: size,
        height: size,
        backgroundColor: '#000',
        borderColor: `${meta.bg}55`,
        padding: provider === 'Anthropic' ? 8 : 10,
      }}
    >
      <img
        src={LOGO_URL[provider]}
        alt={provider}
        className="w-full h-full object-contain"
        draggable={false}
      />
    </div>
  );
}
